import type { ClientConfig } from '../types';

export const CLIENT_DATA: ClientConfig[] = [
	{
		id: 1,
		clientId: 'smart_app_consumer',
		name: 'Smart App Consumer',
		email: 'jpm@aventistechnology.com',
		status: 'Active',
		created: 'May 16, 2025 02:00 AM',
	},
	{
		id: 2,
		clientId: 'smart_app_merchant',
		name: 'Smart App Merchant',
		email: 'jpm@aventistechnology.com',
		status: 'Active',
		created: 'May 16, 2025 02:00 AM',
	},
	{
		id: 3,
		clientId: 'sds',
		name: 'sd',
		email: 'hemanth@aventistechnology.com',
		status: 'Active',
		created: 'Apr 16, 2026 12:40 PM',
	},
	{
		id: 4,
		clientId: 'asd',
		name: 'sd',
		email: 'sds@gmail.co',
		status: 'Active',
		created: 'Apr 25, 2026 01:10 AM',
	},
	{
		id: 5,
		clientId: 'sdfs',
		name: 'connectra--test',
		email: 'adnan@gmail.com',
		status: 'Active',
		created: 'May 20, 2026 02:00 AM',
	},
];
